import api from "./api";

const UserInformationAPI = {
    getByUserId: (userId) => api.get(`/user-information/user/${userId}`),
    lockUnlockUser: (data) => api.post(`/user-information/lock-unlock`, data),
    updUserInformation: (data) => api.post(`/user-information/update-info`, data),
};

export default UserInformationAPI;